import { ENV } from '../utils/useConfig';

const errorMessage: Record<string, string | Record<string, string>> = {
      generic: 'We\'ve encountered an error in the chat. Please try again.',
      'The selected chain id is invalid.': `⚠️ We've encountered an error in your current chain. Please try to switch your wallet network to ${ENV.current_chain} and resend the last message.`,
      'The pledge goal is invalid.': '⚠️ We\'ve encountered an error in your pledge goal. Please try again.',
      'The pledge currency is invalid.': '⚠️ We\'ve encountered an error in your pledge currency. Please try again.',
      'The pledge amount is invalid.': '⚠️ We\'ve encountered an error in your pledge amount. Please try again.',
      'The deadline timestamp is invalid.': '⚠️ We\'ve encountered an error in your pledge deadline. Please try again.',
      'The beneficiary is invalid.': '⚠️ We\'ve encountered an error in your pledge beneficiary. Please try again.',
      'The beneficiary name is invalid.': '⚠️ We\'ve encountered an error in your pledge beneficiary name. Please try again.',
}

function getErrorMessage(key: string) {
  return Object.keys(errorMessage).includes(key) ? errorMessage[key] : errorMessage.generic;
}

export default getErrorMessage;